import VariationLoader from "./components/loader";
import "./components/product_gallery";

/*
    Product amount
*/
function quantityPlus(e, updateCart = false) {
  e.preventDefault();
  let self = e.target;
  if (!self) return false;

  let target = document.querySelector(self.dataset.target);
  if (!target) return false;

  let value = parseInt(target.value) + 1;

  if (target.max && value > parseInt(target.max)) {
    value = parseInt(target.max);
  }

  target.value = value;
  const changeEvent = new Event("change", {
    bubbles: true,
    cancelable: false,
  });
  target.dispatchEvent(changeEvent);

  if (updateCart) {
    jQuery('.woocommerce-cart-form :input[name="update_cart"]').prop("disabled", false);
    jQuery("[name='update_cart']").trigger("click");
  }
}

function quantityMinus(e, updateCart = false) {
  e.preventDefault();
  let self = e.target;

  if (!self) return false;

  let target = document.querySelector(self.dataset.target);
  if (!target) return false;

  let value = parseInt(target.value) - 1;

  if (target.min && value < parseInt(target.min)) {
    value = parseInt(target.min);
  }

  target.value = value;

  const changeEvent = new Event("change", {
    bubbles: true,
    cancelable: false,
  });
  target.dispatchEvent(changeEvent);

  if (updateCart) {
    jQuery('.woocommerce-cart-form :input[name="update_cart"]').prop("disabled", false);
    jQuery("[name='update_cart']").trigger("click");
  }
}
jQuery(document).on("click", ".quantity-plus", (e) => {
  quantityPlus(e);
});
jQuery(document).on("click", ".quantity-minus", (e) => {
  quantityMinus(e);
});

jQuery(document).on("ajaxComplete", (e) => {
  document.body.classList.remove("preload");
});

const radiosWrapper = document.querySelectorAll(".variation-custom-radio-wrapper");
radiosWrapper.forEach((wrapper) => {
  const radios = wrapper.querySelectorAll("input");
  radios.forEach((el) => {
    el.addEventListener("change", () => {
      const $select = jQuery(`select[name=${el.getAttribute("name")}]`);
      $select.val(el.value);
      $select.trigger("change");
    });
  });
});

window.addEventListener("DOMContentLoaded", () => {
  const variationsProducts = document.querySelectorAll(".after-product .product") ? document.querySelectorAll(".related .product") : document.querySelectorAll(".product");

  variationsProducts?.forEach((product) => {
    const variations = product.querySelectorAll(".variations > button");
    let isRunning = false;

    variations?.forEach((variation) => {
      variation.addEventListener("click", async () => {
        if (isRunning) return;
        if (variation.classList.contains("active")) return;
        let price = product.querySelector(".price");
        let btn = product.querySelector(".btn-add-to-cart");
        product.classList.add("loading");
        price.innerHTML = "";
        const loader = VariationLoader.get(price, "beforeend");
        product.querySelector("[data-variation].active").classList.remove("active");
        variation.classList.add("active");
        isRunning = true;
        const formData = new FormData();
        formData.append("action", "update_variation");
        formData.append("variation_id", variation.dataset.variation);
        let response = await fetch(wtm_global_vars._wtm_ajax, {
          method: "POST",
          body: formData,
        });
        response = await response.json();

        loader.remove();
        product.classList.remove("loading");
        let template = document.createElement("template");
        template.innerHTML = response.price;
        const newPrice = template.content.childNodes[0].innerHTML;
        price.innerHTML = newPrice;
        template.innerHTML = response.link;
        template.content.childNodes[0].getAttributeNames().forEach((attr) => {
          if (attr == "class") return;
        });
        isRunning = false;
      });
    });
  });
});
